var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuppyFeatureWhimsical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 11.6667C17.075 10.45 18.3333 8.99167 18.3333 7.08333C18.3333 5.86776 17.8504 4.70197 16.9909 3.84243C16.1314 2.98289 14.9656 2.5 13.75 2.5C12.2833 2.5 11.25 2.91667 10 4.16667C8.75 2.91667 7.71667 2.5 6.25 2.5C5.03442 2.5 3.86864 2.98289 3.00909 3.84243C2.14955 4.70197 1.66667 5.86776 1.66667 7.08333C1.66667 9 2.91667 10.4583 4.16667 11.6667L10 17.5L15.8333 11.6667Z",
    stroke: "var(--stroke-0, #DDB892)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuppyFeatureWhimsical);
export default __webpack_public_path__ + "static/media/puppy-feature-whimsical.d883c7adc1bb787634b21a0bed2da137.svg";
export { ForwardRef as ReactComponent };